import React from "react"

const defaultState = {
  item: "valorContexto",
  setItemValue: (itemValue) => {},
  key: "valorContextoKey",
  setKeyValue: (keyValue) => {},
}

const ItemContext = React.createContext(defaultState)

class ItemProvider extends React.Component {
  state = {
    item: "estadoContexto",
    key: "estadoKeyContexto",
  }

  setItemValue = (itemValue) => {
    localStorage.setItem("item", JSON.stringify(itemValue))
    this.setState({ item: itemValue })
  }

  setKeyValue = (keyValue) => {
    localStorage.setItem("key", JSON.stringify(keyValue))
    this.setState({ key: keyValue })
  }

  componentDidMount() {
    const lsItem = JSON.parse(localStorage.getItem("item"))
    if (lsItem) {
      this.setState({ item: lsItem })
    }

    const lsKey = JSON.parse(localStorage.getItem("key"))
    if (lsKey) {
      this.setState({ key: lsKey })
    }
  }

  render() {
    const { children } = this.props
    const { item, key } = this.state
    
    return (
      <ItemContext.Provider
        value={{
            item,
            setItemValue: this.setItemValue,
            key,
            setKeyValue: this.setKeyValue,
        }}
      >
        {children}
      </ItemContext.Provider>
    )
  }
}

export default ItemContext

export { ItemProvider }
